export enum VoucherDiscountTypeEnum {
    PERCENT = 'PERCENT',
    VALUE = 'VALUE'
}